<template>
    <b-col cols="12"
        lg="6"
        id="user_password"
        class="user_password tr">
        <form @submit.prevent="validate">
            <b-row>
                <b-col cols
                       lg="12">
                    <div class="form-item form-item-text" :class="{ 'field-error': errors.has('current_password') && showErrors }">
                        <label for="settings_current_password"
                               class="form-label">
                            Current password
                        </label>
                        <input  id="settings_current_password"
                                class="settings-current-password"
                                name="current_password"
                                v-model="currentPassword"
                                v-validate
                                data-vv-rules="required"
                                data-vv-as="current password"
                                :disabled="progress"
                                type="password">
                        <p class="field-error--description" v-show="errors.has('current_password') && showErrors">{{ errors.first('current_password') }}</p>
                    </div>
                    <div class="form-item form-item-text" :class="{ 'field-error': errors.has('new_password') && showErrors }">
                        <label for="settings_new_password"
                               class="form-label">
                            New password
                        </label>
                        <input  id="settings_new_password"
                                class="settings-new-password"
                                name="new_password"
                                ref="new_password"
                                v-model="newPassword"
                                v-validate
                                data-vv-rules="required|min:8|max:255"
                                data-vv-as="new password"
                                :disabled="progress"
                                type="password">
                        <p class="field-error--description" v-show="errors.has('new_password') && showErrors">{{ errors.first('new_password') }}</p>
                    </div>
                    <div class="form-item form-item-text" :class="{ 'field-error': errors.has('repeat_password') && showErrors }">
                        <label for="settings_repeat_password"
                               class="form-label">
                            Repeat password
                        </label>
                        <input  id="settings_repeat_password"
                                class="settings-repeat-password"
                                name="repeat_password"
                                v-model="repeatPassword"
                                v-validate
                                data-vv-rules="confirmed:new_password|required"
                                data-vv-as="repeat password"
                                :disabled="progress"
                                type="password">
                        <p class="field-error--description" v-show="errors.has('repeat_password') && showErrors">{{ errors.first('repeat_password') }}</p>
                    </div>
                </b-col>
                <b-col cols="12"
                       lg="5">
                </b-col>
                <b-col cols="12"
                       lg="7">
                    <button class="button--primary"
                            :class="{ 'button--progress': progress }"
                            :type="progress ? 'button' : 'submit'">Save password</button>
                </b-col>
            </b-row>
        </form>
    </b-col>
</template>

<script>
    export default {
        dependencies: ['api', 'popup', 'status'],
        data () {
            return {
                progress: false,
                currentPassword: '',
                newPassword: '',
                repeatPassword: '',
                showErrors: false,
            }
        },
        methods: {
            clearData () {
                this.currentPassword    = '';
                this.newPassword        = '';
                this.repeatPassword     = '';
            },
            validate () {
                this.showErrors = false;
                this.$validator.validateAll().then(() => {
                    if (!this.errors.any()) {
                        this.submit();
                    } else {
                        this.showErrors = true;
                    }
                })
            },
            submit () {
                this.progress = true;

                this.$http.post(this.api.user.password.change, {
                    oldPassword: this.currentPassword,
                    newPassword: this.newPassword,
                    newPasswordConfirmed: this.repeatPassword
                }).then(() => {
                    this.popup.show('Password was changed successfully!', 'OK', false);
                    this.clearData();
                    this.progress = false;
                }, error => {
                    switch (error.status) {
                        case 422:
                            this.popup.show(error.data.errors[0].message, 'OK', false);
                            break;
                        default:
                            if (this.status['status' + error.status]) {
                                this.status['status' + error.status]();
                            } else {
                                this.popup.show(error.data.errors[0].message, 'OK', false);
                            }
                    }
                    this.progress = false;
                })
            }
        },
        beforeMount () {
            this.clearData();
        }
    }
</script>

<style lang="scss">
    @import '../../../../../../../assets/scss/_colors.scss';

    .user_password{

        h3{
            color: $base1;
            font-weight: bold;
            margin: 0;
        }

        p
        {
            margin-top: 10px;
        }

        button{
            width: 100%;
            margin-top: 20px;
        }

        input{
            width: 100%;
        }

        select{
            width: 100%;
            box-sizing: border-box;
        }

    }

    @media(max-width:991px){
        .user_password{
            margin-top: 30px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/profile/settings/UserPassword.vue